import { render } from "./EditAccountManager.vue?vue&type=template&id=70f9db5d"
import script from "./EditAccountManager.vue?vue&type=script&lang=js"
export * from "./EditAccountManager.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/hospitals/labAccountManagers/EditAccountManager.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "70f9db5d"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('70f9db5d', __exports__)) {
    console.log('reload')
    api.reload('70f9db5d', __exports__)
  }
  
  module.hot.accept("./EditAccountManager.vue?vue&type=template&id=70f9db5d", () => {
    console.log('re-render')
    api.rerender('70f9db5d', render)
  })

}


export default __exports__